export const UsersInputLabel = ({ inputId, labelName }) => {
  return <label className="font-medium" htmlFor={inputId}>{labelName}</label>;
};
